import React, { useState, useEffect, useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Rating } from 'primereact/rating';
import { Button } from 'primereact/button';
import { Tag } from 'primereact/tag';
import { Toast } from 'primereact/toast';
import { Chart } from 'primereact/chart';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import './EstadisticaDeOperadores.scss'
import { getCalificacionBitacoras, getCalificacionGeneralGrafica, getCalificacionOperadorGrafica, getCalificacionOperadorParametrosGenerales, getOperadores, getReporteNominal } from './integracion';
import { Modal, Tooltip } from '@mui/material';
import { tooltip } from 'leaflet';
import ModalRutasExcluidas from './partes/ModalRutasExcluidas';
import BotonDescargarExel from '../../../components/atoms/BotonDescargarExel/BotonDescargarExel';
import Swal from 'sweetalert2';
import { formateoBasico } from '../../../utilidades/formateos';




const EstadisticaDeOperadores = () => {
    // Funciones para calcular semanas nominales SUMA (miércoles a martes)
    const calcularSemanasDelAnio = (anio) => {
        const semanas = [];
        const primeroDiciembre = new Date(anio, 0, 1); // 1 de enero del año

        // Encontrar el miércoles de la semana que contiene el 1 de enero
        // Puede estar en diciembre del año anterior
        let primerMiercoles = new Date(primeroDiciembre);
        const diaSemana = primeroDiciembre.getDay(); // 0 = domingo, 3 = miércoles

        // Calcular cuántos días retroceder para llegar al miércoles
        let diasRetroceder;
        if (diaSemana >= 3) {
            // Si es miércoles o después, ir al miércoles de esta semana
            diasRetroceder = diaSemana - 3;
        } else {
            // Si es antes del miércoles (domingo, lunes, martes), ir al miércoles anterior
            diasRetroceder = diaSemana + 4; // 0->4, 1->5, 2->6
        }

        primerMiercoles.setDate(primeroDiciembre.getDate() - diasRetroceder);

        // Generar las 52 semanas
        for (let i = 0; i < 52; i++) {
            const inicioSemana = new Date(primerMiercoles);
            inicioSemana.setDate(primerMiercoles.getDate() + (i * 7));

            const finSemana = new Date(inicioSemana);
            finSemana.setDate(inicioSemana.getDate() + 6); // martes = miércoles + 6 días

            semanas.push({
                label: `Semana ${i + 1}`,
                value: i + 1,
                fechaInicio: inicioSemana,
                fechaFin: finSemana
            });
        }

        return semanas;
    };

    const obtenerSemanaActual = () => {
        const hoy = new Date();
        hoy.setHours(0, 0, 0, 0); // normalizar para comparar solo por fecha
        const semanas = calcularSemanasDelAnio(hoy.getFullYear());

        // Encontrar la semana que contiene la fecha actual
        for (let i = 0; i < semanas.length; i++) {
            if (hoy >= semanas[i].fechaInicio && hoy <= semanas[i].fechaFin) {
                return semanas[i].value;
            }
        }

        // Si no se encuentra, devolver la semana 1
        return 1;
    };

    const obtenerFechasDeSemana = (numeroSemana) => {
        const anioActual = new Date().getFullYear();
        const semanas = calcularSemanasDelAnio(anioActual);
        return semanas[numeroSemana - 1] || semanas[0];
    };

    const [operadores, setOperadores] = useState([]);
    const [expandedRows, setExpandedRows] = useState(null);
    const [modalVisible, setModalVisible] = useState(false);
    const [selectedOperadorId, setSelectedOperadorId] = useState(null);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [semanaSeleccionada, setSemanaSeleccionada] = useState(obtenerSemanaActual());
    const [bitacoras, setBitacoras] = useState([]);
    const [datosGrafica, setDatosGrafica] = useState([]);
    const [datosGraficaGeneral, setDatosGraficaGeneral] = useState([]);
    const [windowWidth, setWindowWidth] = useState(() => (typeof window !== 'undefined' ? window.innerWidth : 1024));
    const [showScrollTop, setShowScrollTop] = useState(false);
    const [calificacionRequerida, setCalificacionRequerida] = useState(70);
    const [montoBitacora, setMontoBitacora] = useState(15);
    const [bitacorasRequeridas, setBitacorasRequeridas] = useState(1);
    const [showPanel, setShowPanel] = useState(true);
    const [parametrosGenerales, setParametrosGenerales] = useState(null);
    const [modalRutasExcluidas, setModalRutasExcluidas] = useState(false);
    const toast = useRef(null);
    const tableContainerRef = useRef(null);

    // ─────────────────────────────────────────────────────────────────────────
    // AJUSTA ESTOS DOS VALORES SEGÚN TU PANTALLA:
    //   HEIGHT_CON_PANEL   → tabla cuando el panel de estadísticas está visible
    //   HEIGHT_SIN_PANEL   → tabla cuando el panel está oculto
    // ─────────────────────────────────────────────────────────────────────────
    const HEIGHT_CON_PANEL = 'max(200px, calc(100vh - 525px))';
    const HEIGHT_SIN_PANEL = 'max(200px, calc(100vh - 210px))';
    // ─────────────────────────────────────────────────────────────────────────
    const [tableScrollHeight, setTableScrollHeight] = useState(HEIGHT_SIN_PANEL);
    useEffect(() => {
        getOperadoresF();
        getCalificacionGeneralGraficaF();
        getGeneralParametros();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    useEffect(() => {
        if (modalVisible) {
            getCalificacionBitacorasF();
            getCalificacionOperadorGraficaF()
        }

    }, [modalVisible]); // eslint-disable-line react-hooks/exhaustive-deps
    const descargarReporte = async (fecha_inicio, fecha_fin) => {
        Swal.fire({
            title: 'Generando reporte...',
            text: 'Esto puede tardar unos segundos. Por favor, espera.',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            const response = await fetch(
                `https://rhflex-api.sumaenlinea.mx/rhflex/getBitacorasOperadorReport?fecha_inicio=${fecha_inicio}&fecha_fin=${fecha_fin}`
            );

            if (!response.ok) throw new Error('Error al generar reporte');

            const blob = await response.blob();
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');

            a.href = url;
            a.download = `bono_stle_${fecha_inicio}_${fecha_fin}.xlsx`;
            a.click();

            URL.revokeObjectURL(url);
            Swal.close();

        } catch (error) {
            console.error('Error:', error);
        }
    };
    // Efecto para recargar datos cuando cambie la semana seleccionada
    useEffect(() => {
        if (semanaSeleccionada) {
            getOperadoresF();
            getCalificacionGeneralGraficaF();
            getGeneralParametros();
        }
    }, [semanaSeleccionada]); // eslint-disable-line react-hooks/exhaustive-deps
    const getCalificacionOperadorGraficaF = async () => {
        try {
            const data = await getCalificacionOperadorGrafica({ idOperador: selectedOperadorId });
            setDatosGrafica(data);
        } catch (error) {
            console.error('Error al obtener las calificaciones para la gráfica:', error);
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'No se pudieron cargar las calificaciones para la gráfica', life: 3000 });
        }
    }
    const getCalificacionGeneralGraficaF = async () => {
        try {
            const data = await getCalificacionGeneralGrafica();
            setDatosGraficaGeneral(data);
        } catch (error) {
            console.error('Error al obtener las calificaciones generales para la gráfica:', error);
        }
    }
    const getCalificacionBitacorasF = async () => {
        try {
            const formatFecha = (fecha) => {
                const year = fecha.getFullYear();
                const month = String(fecha.getMonth() + 1).padStart(2, '0');
                const day = String(fecha.getDate()).padStart(2, '0');
                return `${year}-${month}-${day}`;
            };

            const fechasSemana = obtenerFechasDeSemana(semanaSeleccionada);
            const params = {
                fechaInicio: formatFecha(fechasSemana.fechaInicio),
                fechaFin: formatFecha(fechasSemana.fechaFin),
                idOperador: selectedOperadorId
            };

            const data = await getCalificacionBitacoras(params);
            setBitacoras(data);
        } catch (error) {
            console.error('Error al obtener las calificaciones de bitácoras:', error);
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'No se pudieron cargar las calificaciones de bitácoras', life: 3000 });
        }
    }
    const getGeneralParametros = async () => {
        try {
            const formatFecha = (fecha) => {
                const year = fecha.getFullYear();
                const month = String(fecha.getMonth() + 1).padStart(2, '0');
                const day = String(fecha.getDate()).padStart(2, '0');
                return `${year}-${month}-${day}`;
            };

            const fechasSemana = obtenerFechasDeSemana(semanaSeleccionada);
            const params = {
                fechaInicio: formatFecha(fechasSemana.fechaInicio),
                fechaFin: formatFecha(fechasSemana.fechaFin)
            };

            const data = await getCalificacionOperadorParametrosGenerales(params);
            if (data && data.length > 0) {
                setParametrosGenerales(data[0]);
            }
        } catch (error) {
            console.error('Error al obtener las calificaciones de parámetros generales del operador:', error);
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'No se pudieron cargar las calificaciones de parámetros generales del operador', life: 3000 });
        }
    }
    const getOperadoresF = async () => {
        try {
            // Formatear fechas a YYYY-MM-DD
            const formatFecha = (fecha) => {
                const year = fecha.getFullYear();
                const month = String(fecha.getMonth() + 1).padStart(2, '0');
                const day = String(fecha.getDate()).padStart(2, '0');
                return `${year}-${month}-${day}`;
            };

            const fechasSemana = obtenerFechasDeSemana(semanaSeleccionada);
            const params = {
                fechaInicio: formatFecha(fechasSemana.fechaInicio),
                fechaFin: formatFecha(fechasSemana.fechaFin)
            };

            getOperadores(params).then(data => {
                setOperadores(data);
                // Capturar los valores de requisitos del bono del primer operador
                if (data && data.length > 0) {
                    const primerOperador = data[0];
                    if (primerOperador.CALIFICACION_REQUERIDA !== undefined) {
                        setCalificacionRequerida(primerOperador.CALIFICACION_REQUERIDA);
                    }
                    if (primerOperador.MONTO_BITACORA !== undefined) {
                        setMontoBitacora(primerOperador.MONTO_BITACORA);
                    }
                    if (primerOperador.BITACORAS_REQUERIDAS !== undefined) {
                        setBitacorasRequeridas(primerOperador.BITACORAS_REQUERIDAS);
                    }
                }
            }).catch(error => {
                console.error('Error al obtener los operadores:', error);
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'No se pudieron cargar los operadores', life: 3000 });
            });
        } catch (error) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'No se pudieron cargar los operadores', life: 3000 });
        }
    };
    useEffect(() => {
        setTableScrollHeight(showPanel ? HEIGHT_CON_PANEL : HEIGHT_SIN_PANEL);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showPanel]);

    // Actualizar windowWidth y tableScrollHeight en resize (incluye cambios de zoom)
    useEffect(() => {
        const onResize = () => {
            setWindowWidth(window.innerWidth);
            setTableScrollHeight(showPanel ? HEIGHT_CON_PANEL : HEIGHT_SIN_PANEL);
        };
        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, [showPanel]); // eslint-disable-line react-hooks/exhaustive-deps

    // Control del botón scroll to top
    useEffect(() => {
        const handleScroll = () => {
            setShowScrollTop(window.pageYOffset > 300);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const isMobile = windowWidth < 768;

    const calcularPromedios = () => {
        if (operadores.length === 0) return null;

        const totalCalificacion = operadores.reduce((acc, op) => acc + parseFloat(op['PROM CALIF']), 0);
        const totalAforo = operadores.reduce((acc, op) => acc + parseFloat(op['% AFORO_SI']), 0);
        const totalEcoDrive = operadores.reduce((acc, op) => acc + parseFloat(op['% ECO_DRIVE']), 0);
        const totalEfectividad = operadores.reduce((acc, op) => acc + parseFloat(op['% EFECTIVIDAD']), 0);
        const totalPuntualidad = operadores.reduce((acc, op) => acc + parseFloat(op['% PUNTUALIDAD']), 0);
        const totalArranque = operadores.reduce((acc, op) => acc + parseFloat(op['% ARRANQUE']), 0);
        const ganaBono = operadores.filter(op => op.ELEGIBLE === 'SI').length;

        return {
            calificacionGeneral: (totalCalificacion / operadores.length).toFixed(1),
            aforo: (totalAforo / operadores.length).toFixed(1),
            ecoDrive: (totalEcoDrive / operadores.length).toFixed(1),
            efectividad: (totalEfectividad / operadores.length).toFixed(1),
            puntualidad: (totalPuntualidad / operadores.length).toFixed(1),
            arranque: (totalArranque / operadores.length).toFixed(1),
            totalOperadores: operadores.length,
            ganaBono,
            noGanaBono: operadores.length - ganaBono
        };
    };

    const promedios = calcularPromedios();

    const procesarDatosGraficaGeneral = () => {
        if (!datosGraficaGeneral || datosGraficaGeneral.length === 0) return [];
        const datos = datosGraficaGeneral[0];
        const semanas = [];
        Object.keys(datos).forEach(key => {
            if (/^\d{4}-\d{2}$/.test(key) && datos[key] !== null && datos[key] !== undefined) {
                semanas.push({ mes: key, calificacion: parseFloat(datos[key]) });
            }
        });
        return semanas.sort((a, b) => a.mes.localeCompare(b.mes));
    };
    const datosHistoricosGeneral = procesarDatosGraficaGeneral();

    // const onRowExpand = (event) => {
    //     toast.current.show({ severity: 'info', summary: 'Fila Expandida', detail: event.data.nombre, life: 3000 });
    // };

    // const onRowCollapse = (event) => {
    //     toast.current.show({ severity: 'success', summary: 'Fila Colapsada', detail: event.data.nombre, life: 3000 });
    // };

    const expandAll = () => {
        let _expandedRows = {};
        operadores.forEach((p) => (_expandedRows[`${p['ID OPERADOR']}`] = true));
        setExpandedRows(_expandedRows);
    };

    const collapseAll = () => {
        setExpandedRows(null);
    };

    const imageBodyTemplate = (rowData) => {
        return <img src={rowData.URL_IMAGEN?.trim()} alt={rowData.OPERADOR} style={{ width: 'clamp(40px, 8vw, 50px)', height: 'clamp(40px, 8vw, 50px)', borderRadius: '50%', objectFit: 'cover' }} className="shadow-4" />;
    };

    const ratingBodyTemplate = (rowData) => {
        const calif = parseFloat(rowData['PROM CALIF']);
        return (
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '0.25rem' }}>
                <span style={{ fontSize: 'clamp(0.875rem, 2vw, 1rem)', fontWeight: 'bold', color: '#4f46e5' }}>{calif.toFixed(2)}</span>
                <Rating value={calif / 2} readOnly cancel={false} style={{ fontSize: 'clamp(0.75rem, 1.5vw, 1rem)' }} />
            </div>
        );
    };

    const statusBodyTemplate = (rowData) => {

        return <Tag value={rowData['BONO POR BITACORA']} severity={'success'}></Tag>;
    };
    const statusOperadoresTemplate = (rowData) => {
        return <Tag value={rowData['ACTIVO'] == 1 ? 'Activo' : 'Inactivo'} severity={rowData['ACTIVO'] == 1 ? 'success' : 'danger'}></Tag>;
    }

    const getEstadoSeverity = (operador) => {
        return operador.ELEGIBLE === 'SI' ? 'success' : 'danger';
    };

    const allowExpansion = (rowData) => {
        return rowData.BITACORAS && rowData.BITACORAS > 0;
    };

    const actionsBodyTemplate = (rowData) => {
        return (
            <Button
                icon="pi pi-eye"
                className="p-button-rounded p-button-warning"
                style={{ width: 'clamp(2rem, 5vw, 2.5rem)', height: 'clamp(2rem, 5vw, 2.5rem)' }}
                onClick={() => {
                    setSelectedOperadorId(rowData['ID OPERADOR']);
                    setModalVisible(true);
                }}
            />
        );
    };

    const getColor = (valor, maximo) => {
        const porcentaje = (valor / maximo) * 100;
        if (porcentaje === 0) return '#ef4444'; // rojo
        if (porcentaje < 70) return '#f59e0b'; // amarillo
        return '#10b981'; // verde
    };
    const getColorAforo = (valor, maximo) => {
        const porcentaje = (valor / maximo) * 100;
        if (porcentaje === 0) return '#ef4444'; // rojo
        return '#10b981'; // verde
    };
    const getColorEcodrive = (valor, maximo) => {
        const porcentaje = (valor / maximo) * 100;
        if (porcentaje < 90) return '#ef4444'; // rojo
        if (porcentaje == 90) return '#f59e0b'; // amarillo
        return '#10b981'; // verde
    };
    const getColorEfectividad = (valor, maximo) => {
        const porcentaje = (valor / maximo) * 100;
        if (porcentaje < 85) return '#ef4444'; // rojo
        if (porcentaje == 85) return '#f59e0b'; // amarillo
        return '#10b981'; // verde
    };




    const getChartData = (datos) => {
        if (!datos || datos.length === 0) {
            return {
                labels: [],
                datasets: []
            };
        }

        // Mes actual en formato YYYY-MM
        const hoy = new Date();
        const mesActual = `${hoy.getFullYear()}-${String(hoy.getMonth() + 1).padStart(2, '0')}`;

        return {
            labels: datos.map(d => d.mes),
            datasets: [
                {
                    label: 'Calificación Semanal',
                    data: datos.map(d => d.calificacion),
                    fill: false,
                    borderColor: '#4f46e5',
                    backgroundColor: '#4f46e5',
                    tension: 0.4,
                    pointBackgroundColor: datos.map(d =>
                        d.mes === mesActual ? '#dc2626' : '#4f46e5'
                    ),
                    pointBorderColor: '#fff',
                    pointBorderWidth: 2,
                    pointRadius: 6
                }
            ]
        };
    };

    const chartOptions = {
        maintainAspectRatio: false,
        aspectRatio: 0.6,
        plugins: {
            legend: {
                display: false
            }
        },
        scales: {
            x: {
                title: {
                    display: true,
                    text: 'Semana',
                    font: {
                        size: 14,
                        weight: 'bold'
                    },
                    color: '#374151'
                }
            },
            y: {
                beginAtZero: false,
                ticks: {
                    stepSize: 5
                }
            }
        }
    };

    const rowExpansionTemplate = (data) => {
        const aforo = parseFloat(data['% AFORO_SI']);
        const ecoDrive = parseFloat(data['% ECO_DRIVE']);
        const efectividad = parseFloat(data['% EFECTIVIDAD']);
        const puntualidad = parseFloat(data['% PUNTUALIDAD']); // % cumplimiento puntualidad
        const arranque = parseFloat(data['% ARRANQUE']);       // % cumplimiento arranque
        const calif = parseFloat(data['PROM CALIF']);
        const puntajeFinal = parseFloat(data['PUNTAJE FINAL']);
        const colisiones = parseInt(data.COLISIONES) || 0;
        const dormidoNegado = parseInt(data.DORMIDO_NEGADO) || 0;
        const caidoTaxiInicioTarde = parseInt(data.CAIDO_TAXI_INICIOTARDE) || 0;

        // Función para obtener el color según el valor (verde si es 0, rojo si es mayor a 0)
        const getIncidentColor = (valor) => {
            return valor === 0 ? '#10b981' : '#ef4444';
        };

        return (
            <div className="expansion-content">
                <div className="expansion-card">
                    <div className="expansion-grid">
                        {/* Sección de perfil */}
                        <div className="perfil-section">
                            <img src={data.URL_IMAGEN?.trim()} alt={data.OPERADOR} className="perfil-foto" />
                            <h4 className="perfil-nombre">{data.OPERADOR}</h4>
                            <div className="perfil-rating">
                                {/* <span className="perfil-calificacion">{calif.toFixed(2)}</span> */}
                                <Rating value={calif / 2} readOnly cancel={false} />
                            </div>
                            <div className="calificacion-container">
                                {/* <div className="calificacion-semanal">
                                    <div className='calficacionGeneral' style={{ background: getColor(calif, 10) }}>{calif.toFixed(2)}</div>
                                    <b><span style={{ fontSize: 'clamp(0.7rem, 2vw, 0.8rem)', color: '#595e66', textAlign: 'center', display: 'block' }}>Prom. Calificación</span></b>
                                </div> */}
                                <div className="calificacion-semanal" style={{ marginTop: '0.5rem' }}>
                                    <div className='calficacionGeneral' style={{ background: getColor(puntajeFinal, 100) }}>{isNaN(puntajeFinal) ? '-' : puntajeFinal.toFixed(1)}</div>
                                    <b><span style={{ fontSize: 'clamp(0.7rem, 2vw, 0.8rem)', color: '#595e66', textAlign: 'center', display: 'block' }}>Puntaje Final</span></b>
                                </div>
                            </div>
                            {/* <span>{data.BITACORAS} Bitácoras ({data.ARRANQUE_CUMPLEN}/{data.ARRANQUE_TOTAL} arranques)</span> */}
                        </div>

                        {/* Sección de estadísticas */}
                        <div className="estadisticas-section">
                            <h5 className="seccion-titulo">Estadísticas de Evaluación</h5>
                            <div className="estadisticas-grid">
                                <div className="stat-card-estadistica-op">
                                    <Tooltip title="Al menos un registro de pasajeros vía QR o sin él.">
                                        <div className="stat-indicator" style={{ backgroundColor: getColorAforo(aforo, 100) }}></div>
                                        <div className="stat-label">Aforo</div>
                                        <div className="stat-value">{aforo.toFixed(1)}%</div>
                                        <div className="stat-percentage">{data.AFORO_CUMPLEN}/{data.AFORO_TOTAL}</div>
                                    </Tooltip>
                                </div>
                                <div className="stat-card-estadistica-op">
                                    <Tooltip title={"Calificación de conducción a través del GPS."} placement="top" arrow>
                                        <div className="stat-indicator" style={{ backgroundColor: getColorEcodrive((ecoDrive.toFixed(1) * 10).toFixed(1), 100) }}></div>
                                        <div className="stat-label">Eco-Drive</div>
                                        <div className="stat-value">{(ecoDrive.toFixed(1) * 10).toFixed(1)}%</div>
                                        <div className="stat-percentage">Min - 90%</div>
                                    </Tooltip>
                                </div>

                                <div className="stat-card-estadistica-op">
                                    <Tooltip title={"Seguimiento de ruta, de acuerdo al trazo diseñado por operaciones."} placement="top" arrow>
                                        <div className="stat-indicator" style={{ backgroundColor: getColorEfectividad(efectividad, 100) }}></div>
                                        <div className="stat-label">Efectividad</div>
                                        <div className="stat-value">{efectividad.toFixed(1)}%</div>
                                        <div className="stat-percentage">Min - 85% (Trazo)</div>
                                    </Tooltip>
                                </div>
                                <div className="stat-card-estadistica-op">
                                    <Tooltip title={"Inicio en tiempo, de acuerdo a la hora de arranque."} placement="top" arrow>
                                        <div className="stat-indicator" style={{ backgroundColor: getColor(puntualidad, 100) }}></div>
                                        <div className="stat-label">Puntualidad</div>
                                        <div className="stat-value">{puntualidad.toFixed(1)}%</div>
                                        <div className="stat-percentage">{data.PUNTUALIDAD_CUMPLEN}/{data.PUNTUALIDAD_TOTAL}</div>
                                    </Tooltip>
                                </div>
                                <div className="stat-card-estadistica-op">
                                    <Tooltip title={"Arranque en punto de inicio validado por geocerca."} placement="top" arrow>
                                        <div className="stat-indicator" style={{ backgroundColor: getColor(arranque, 100) }}></div>
                                        <div className="stat-value">{arranque.toFixed(1)}%</div>
                                        <div className="stat-label">Arranque en inicio</div>
                                        <div className="stat-percentage">{data.ARRANQUE_CUMPLEN}/{data.ARRANQUE_TOTAL}</div>
                                    </Tooltip>
                                </div>
                            </div>
                            {/* Sección de incidentes */}
                            <div style={{ width: '100%', marginTop: '1.5rem', display: 'flex', justifyContent: 'center' }}>
                                <div style={{ display: 'flex', gap: 'clamp(1rem, 4vw, 2rem)', flexWrap: 'wrap', justifyContent: 'center' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', gap: '0.5rem', minWidth: 'clamp(80px, 20vw, 120px)' }}>

                                        <span style={{
                                            fontSize: 'clamp(0.7rem, 2vw, 0.875rem)',
                                            fontWeight: '600',
                                            textAlign: 'center'
                                        }}>
                                            Colisiones: {colisiones}
                                        </span>
                                        <div style={{
                                            width: 'clamp(35px, 10vw, 44px)',
                                            height: 'clamp(3px, 1vw, 4px)',
                                            backgroundColor: getIncidentColor(colisiones),
                                            borderRadius: '2px'
                                        }}></div>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', gap: '0.5rem', minWidth: 'clamp(100px, 25vw, 140px)' }}>

                                        <span style={{
                                            fontSize: 'clamp(0.7rem, 2vw, 0.875rem)',
                                            fontWeight: '600',
                                            textAlign: 'center'
                                        }}>
                                            Dormido/Negado: {dormidoNegado}
                                        </span>
                                        <div style={{
                                            width: 'clamp(35px, 10vw, 44px)',
                                            height: 'clamp(3px, 1vw, 4px)',
                                            backgroundColor: getIncidentColor(dormidoNegado),
                                            borderRadius: '2px'
                                        }}></div>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', gap: '0.5rem', minWidth: 'clamp(120px, 30vw, 160px)' }}>

                                        <span style={{
                                            fontSize: 'clamp(0.7rem, 2vw, 0.875rem)',
                                            fontWeight: '600',
                                            textAlign: 'center'
                                        }}>
                                            Caído/Taxi/InicioTarde: {caidoTaxiInicioTarde}
                                        </span>
                                        <div style={{
                                            width: 'clamp(35px, 10vw, 44px)',
                                            height: 'clamp(3px, 1vw, 4px)',
                                            backgroundColor: getIncidentColor(caidoTaxiInicioTarde),
                                            borderRadius: '2px'
                                        }}></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >

        );
    };

    const header = (
        <div className="flex flex-wrap justify-content-between align-items-center gap-2" style={{ padding: 'clamp(0.5rem, 2vw, 1rem) 0', width: "100%" }}>
            <div className="flex gap-2 flex-wrap align-items-center" style={{ width: '100%', justifyContent: "space-between" }}>

                {showPanel && (
                    <div className="flex gap-2 align-items-center" style={{ marginLeft: '1rem' }}>
                        <label style={{ fontSize: '0.875rem', color: '#6b7280', fontWeight: '500' }}>Semanas Operativas SUMA:</label>
                        <Dropdown
                            value={semanaSeleccionada}
                            onChange={(e) => setSemanaSeleccionada(e.value)}
                            options={calcularSemanasDelAnio(new Date().getFullYear())}
                            placeholder="Selecciona una semana"
                            style={{ width: 'clamp(180px, 20vw, 220px)' }}
                        />
                        <div style={{
                            fontSize: '0.75rem',
                            color: '#4f46e5',
                            fontWeight: '600',
                            padding: '0.5rem 0.75rem',
                            backgroundColor: '#eef2ff',
                            borderRadius: '6px',
                            border: '1px solid #c7d2fe'
                        }}>
                            {(() => {
                                const fechas = obtenerFechasDeSemana(semanaSeleccionada);
                                const formatoFecha = (fecha) => {
                                    return fecha.toLocaleDateString('es-MX', {
                                        day: '2-digit',
                                        month: '2-digit',
                                        year: 'numeric'
                                    });
                                };
                                return `${formatoFecha(fechas.fechaInicio)} - ${formatoFecha(fechas.fechaFin)}`;
                            })()}
                        </div>
                        <Button
                            icon="pi pi-refresh"
                            className="p-button-rounded p-button-text"
                            onClick={getOperadoresF}
                            tooltip="Actualizar datos"
                            tooltipOptions={{ position: 'top' }}
                        />
                    </div>
                )}
                {showPanel && (
                    <div className="requisitos-bono-container">
                        <div className="requisito-item">
                            <i className="pi pi-star-fill" style={{ color: '#f59e0b' }}></i>
                            <div className="requisito-content">
                                <span className="requisito-label">Calificación Mínima</span>
                                <span className="requisito-valor">{calificacionRequerida}</span>
                            </div>
                        </div>
                        <div className="requisito-separador"></div>
                        <div className="requisito-item">
                            <i className="pi pi-dollar" style={{ color: '#10b981' }}></i>
                            <div className="requisito-content">
                                <span className="requisito-label">Bono por Bitácora</span>
                                <span className="requisito-valor">${montoBitacora}</span>
                            </div>
                        </div>
                        <div className="requisito-separador"></div>
                        <div className="requisito-item">
                            <i className="pi pi-file" style={{ color: '#4f46e5' }}></i>
                            <div className="requisito-content">
                                <span className="requisito-label">Bitácoras Requeridas</span>
                                <span className="requisito-valor">{bitacorasRequeridas}</span>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            <span className="p-input-icon-left">

                {/* <i className="pi pi-search" /> */}
                <div className='generales'>


                    <Button
                        icon="pi pi-plus"
                        label="Expandir todo"
                        className="p-button-text p-button-sm"
                        onClick={expandAll}
                        style={{ fontSize: 'clamp(0.75rem, 2vw, 0.875rem)' }}
                    />
                    <Button
                        icon="pi pi-minus"
                        label="Colapsar todo"
                        className="p-button-text p-button-sm"
                        onClick={collapseAll}
                        style={{ fontSize: 'clamp(0.75rem, 2vw, 0.875rem)', height: '35px' }}
                    />
                    <InputText
                        value={globalFilterValue}
                        onChange={(e) => setGlobalFilterValue(e.target.value)}
                        placeholder="Buscar operador..."
                        style={{ width: 'clamp(200px, 30vw, 300px)' }}
                    />
                </div>
                <div className='generales'>

                    <Button
                        style={{ fontSize: "0.78rem",height: "35px" }}
                        label="Rutas excluidas"
                        icon="pi pi-info-circle"
                        
                        onClick={() => { setModalRutasExcluidas(true) }}
                    ></Button>
                    <BotonDescargarExel
                        descripcion='Evaluaciones'
                        nombreArchivo="Estadistica_Operadores"
                        datos={operadores.map(op => ({
                            Nombre: op['OPERADOR'],
                            Calificacion: op['PROM CALIF'],
                            'Num. Bitacoras': op['BITACORAS'],
                            'Bono Acumulado': op['BONO POR BITACORA'],
                        }))}
                    />
                   <Button severity='success' icon="pi pi-file" style={{fontSize: "0.78rem", height: "35px"}}
                           label="Nomina" onClick={() => {
                       const fechas = obtenerFechasDeSemana(semanaSeleccionada);
                       descargarReporte(
                           fechas.fechaInicio.toISOString().split('T')[0],
                           fechas.fechaFin.toISOString().split('T')[0]
                       );
                   }}
                   />
                </div>
            </span>
        </div>
    );

    return (
        <div className="EstadisticaDeOperadores">
            <Toast ref={toast} />

            {/* Barra superior con botón toggle */}

            <Button
                icon={showPanel ? 'pi pi-chevron-up' : 'pi pi-chevron-down'}
                className="p-button-sm p-button-text p-button-secondary button-position btn-toggle-panel"
                onClick={() => setShowPanel(prev => !prev)}
                style={{ fontSize: '0.8rem', width: 40, height: 40, borderRadius: '50%' }}
            />


            {/* Card de Promedios - Compacto + Gráfica General */}
            {showPanel && parametrosGenerales && (
                <div className="card-promedios-destacado">
                    <div className="promedios-dashboard-container">
                        {/* Estadísticas compactas */}
                        <div className="promedios-stats-compact">
                            <div className="promedios-top-row">
                                <div className="mini-stat-group">
                                    <span className="section-title-eo">Promedio General</span>
                                    <div className="mini-stat-valor-row">
                                        <span className="promedio-compact">{parseFloat(parametrosGenerales.calificacionGeneral).toFixed(2)}</span>
                                        <Rating value={parseFloat(parametrosGenerales.calificacionGeneral) / 2} readOnly cancel={false} className="rating-responsive" />
                                    </div>
                                </div>
                                <div className="ministat-divider"></div>
                                <div className="mini-stat-group">
                                    <span className="section-title-eo">Bono Total</span>
                                    <div className="mini-stat-valor-row">
                                        <span className="promedio-compact">{parametrosGenerales.totalBono}</span>
                                    </div>
                                </div>
                                <div className="ministat-divider"></div>
                                <div className="mini-stat-group">
                                    <span className="section-title-eo">Operadores</span>
                                    <div className="mini-stat-valor-row">
                                        <span className="total-compact">{operadores?.length}</span>
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.1rem' }}>
                                            <span className="elegibles-text">✓ {parametrosGenerales.ganaBono} Elegibles</span>
                                            <span className="no-elegibles-text">✗ {parametrosGenerales.noGanaBono} No elegibles</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="categorias-pills-row">
                                {[
                                    { label: 'Aforo', valor: parametrosGenerales.aforo, tooltip: "Al menos un registro de pasajeros vía QR o sin él." },
                                    { label: 'Eco-Drive', valor: parametrosGenerales.ecoDrive, tooltip: "Calificación de conducción a través del GPS. " },
                                    { label: 'Efectividad', valor: parametrosGenerales.efectividad, tooltip: "Seguimiento de ruta, de acuerdo al trazo diseñado por operaciones." },
                                    { label: 'Puntualidad', valor: parametrosGenerales.puntualidad, tooltip: "Inicio en tiempo, de acuerdo a la hora de arranque." },
                                    { label: 'Arranque en inicio', valor: parametrosGenerales.arranque, tooltip: "Arranque en punto de inicio validado por geocerca." },
                                ].map(cat => (
                                    <Tooltip key={cat.label} title={cat.tooltip} placement="top" arrow>
                                        <div key={cat.label} className="categoria-pill">
                                            <div style={{ width: '10px', height: '10px', borderRadius: '50%', backgroundColor: getColor(parseFloat(cat.valor), 100), flexShrink: 0 }}></div>
                                            <span className="pill-label">{cat.label}</span>
                                            <span className="pill-valor">{cat.valor}%</span>
                                        </div>
                                    </Tooltip>
                                ))}
                            </div>
                        </div>
                        {/* Gráfica General */}
                        <div className="grafica-general-container">
                            <span className="section-title-eo">Histórico General Semanal</span>
                            <div className="grafica-general-chart">
                                {datosHistoricosGeneral.length > 0 ? (
                                    <Chart type="line" data={getChartData(datosHistoricosGeneral)} options={chartOptions} style={{ height: '200px' }} />
                                ) : (
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', color: '#6b7280', fontSize: '0.875rem' }}>
                                        No hay datos históricos disponibles
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Tabla de Operadores */}
            <div className="card tabla-container" ref={tableContainerRef}>
                <DataTable
                    value={operadores}
                    expandedRows={expandedRows}
                    onRowToggle={(e) => setExpandedRows(e.data)}
                    rowExpansionTemplate={rowExpansionTemplate}
                    dataKey="ID OPERADOR"
                    header={header}
                    globalFilter={globalFilterValue}
                    globalFilterFields={['OPERADOR', 'PROM CALIF', 'ELEGIBLE']}
                    stripedRows
                    scrollable
                    scrollHeight={tableScrollHeight}
                    virtualScrollerOptions={{ itemSize: 46 }}
                    breakpoint="960px"
                    className="responsive-table"
                    emptyMessage="No se encontraron operadores"
                >
                    <Column expander={allowExpansion} style={{ width: '3rem' }} className="col-expander" />
                    {!isMobile && (
                        <Column header="Foto" body={imageBodyTemplate} style={{ width: '4rem' }} className="col-foto" />
                    )}
                    <Column field="OPERADOR" header="Nombre" sortable style={{ minWidth: '120px' }} className="col-nombre" />
                    {!isMobile && (
                        <Column field="PROM CALIF" header="Calificación" sortable body={ratingBodyTemplate} style={{ minWidth: '120px' }} className="col-calificacion" />
                    )}
                    {!isMobile && (
                        <Column field="BITACORAS" header="N° Bitácoras" sortable className="col-calificacion" />
                    )}
                    <Column field="BONO POR BITACORA" header="Bono Acumulado" sortable body={statusBodyTemplate} style={{ minWidth: '100px' }} className="col-estado" />
                    <Column field="ACTIVO" header="Estado" sortable body={statusOperadoresTemplate} style={{ minWidth: '100px' }} className="col-estado" />
                    <Column header="Acciones" body={actionsBodyTemplate} style={{ width: '80px', textAlign: 'center' }} className="col-acciones" />
                </DataTable>
            </div>

            <Dialog
                header="Detalle del Operador"
                visible={modalVisible}
                style={{ width: '90vw', maxWidth: '1200px' }}
                onHide={() => setModalVisible(false)}
                breakpoints={{ '960px': '90vw', '640px': '100vw' }}
                contentStyle={{ overflow: 'auto', maxHeight: '80vh', padding: '1rem' }}
                dismissableMask
            >
                {selectedOperadorId && operadores.find(op => op['ID OPERADOR'] === selectedOperadorId) && (() => {
                    // const operador = operadores.find(op => op['ID OPERADOR'] === selectedOperadorId);
                    // const calif = parseFloat(operador['PROM CALIF']);
                    // const aforo = parseFloat(operador['% AFORO_SI']);
                    // const ecoDrive = parseFloat(operador['% ECO_DRIVE']);
                    // const efectividad = parseFloat(operador['% EFECTIVIDAD']);
                    // const puntualidad = parseFloat(operador['% PUNTUALIDAD']); // % cumplimiento
                    // const arranque = parseFloat(operador['% ARRANQUE']);       // % cumplimiento
                    // const puntajeFinalModal = parseFloat(operador['PUNTAJE FINAL']);
                    // const estado = operador.ELEGIBLE === 'SI' ? 'Elegible' : 'No elegible';

                    // Procesar datos de gráfica
                    const procesarDatosGrafica = () => {
                        if (!datosGrafica || datosGrafica.length === 0) return [];

                        const datos = datosGrafica[0];
                        const meses = [];

                        // Extraer los meses dinámicamente (todos los campos que son fechas YYYY-MM)
                        Object.keys(datos).forEach(key => {
                            if (/^\d{4}-\d{2}$/.test(key)) {
                                const valor = datos[key];
                                if (valor !== null) {
                                    meses.push({ mes: key, calificacion: parseFloat(valor) });
                                }
                            }
                        });

                        return meses.sort((a, b) => a.mes.localeCompare(b.mes));
                    };

                    const datosHistoricos = procesarDatosGrafica();

                    // Template para mostrar porcentajes como texto
                    const textTemplate = (value) => {
                        const color = value >= 90 ? '#10b981' : value >= 70 ? '#f59e0b' : '#ef4444';
                        return (
                            <span style={{
                                fontSize: '1rem',
                                fontWeight: 'bold',
                                color: color
                            }}>
                                {value}
                            </span>
                        );
                    };
                    // Template para mostrar porcentajes como texto
                    const textTemplateAforos = (value) => {
                        const color = value > 0 ? '#10b981' : '#ef4444';
                        return (
                            <span style={{
                                fontSize: '1rem',
                                fontWeight: 'bold',
                                color: color
                            }}>
                                {value}
                            </span>
                        );
                    };
                    // Template para mostrar porcentajes como texto
                    const textTemplateEcodrive = (value) => {
                        const color = value >= 90 ? '#10b981' : value >= 70 ? '#f59e0b' : '#ef4444';
                        return (
                            <span style={{
                                fontSize: '1rem',
                                fontWeight: 'bold',
                                color: color
                            }}>
                                {value}%
                            </span>
                        );
                    };
                    const textTemplateEfectividad = (value) => {
                        const color = value > 84 ? '#10b981' : value >= 70 ? '#f59e0b' : '#ef4444';
                        return (
                            <span style={{
                                fontSize: '1rem',
                                fontWeight: 'bold',
                                color: color
                            }}>
                                {value}%
                            </span>
                        );
                    };
                    const textTemplatePuntualidad = (value) => {
                        const color = value <= 5 ? '#10b981' : value == 5 ? '#f59e0b' : '#ef4444';
                        return (
                            <span style={{
                                fontSize: '1rem',
                                fontWeight: 'bold',
                                color: color
                            }}>
                                {value}-min
                            </span>
                        );
                    };
                    const textTemplateArranque = (value) => {
                        const color = value === 'Si' ? '#10b981' : '#ef4444';
                        return (
                            <span style={{
                                fontSize: '1rem',
                                fontWeight: 'bold',
                                color: color
                            }}>
                                {value}
                            </span>
                        );
                    };

                    // Función para detectar si una fila tiene incidencias
                    const rowClassName = (rowData) => {
                        const colisiones = parseInt(rowData.COLISIONES) || 0;
                        const dormidoNegado = parseInt(rowData.DORMIDO_NEGADO) || 0;
                        const caidoTaxiInicioTarde = parseInt(rowData.CAIDO_TAXI_INICIOTARDE) || 0;

                        if (colisiones > 0 || dormidoNegado > 0 || caidoTaxiInicioTarde > 0) {
                            return 'bitacora-con-incidencias';
                        }
                        return '';
                    };

                    // Template para mostrar incidencias con tooltip
                    const incidenciasTemplate = (rowData) => {
                        const colisiones = parseInt(rowData.COLISIONES) || 0;
                        const dormidoNegado = parseInt(rowData.DORMIDO_NEGADO) || 0;
                        const caidoTaxiInicioTarde = parseInt(rowData.CAIDO_TAXI_INICIOTARDE) || 0;
                        const totalIncidencias = colisiones + dormidoNegado + caidoTaxiInicioTarde;

                        if (totalIncidencias > 0) {
                            const tooltipContent = [
                                colisiones > 0 ? `Colisiones: ${colisiones}` : null,
                                dormidoNegado > 0 ? `Dormido/Negado: ${dormidoNegado}` : null,
                                caidoTaxiInicioTarde > 0 ? `Caído/Taxi/InicioTarde: ${caidoTaxiInicioTarde}` : null
                            ].filter(Boolean).join(' | ');

                            return (
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <i
                                        className="pi pi-exclamation-triangle"
                                        style={{ color: '#ef4444', fontSize: '1.2rem' }}
                                        title={tooltipContent}
                                    ></i>
                                    <span style={{ marginLeft: '0.5rem', color: '#ef4444', fontWeight: 'bold' }}>
                                        {totalIncidencias}
                                    </span>
                                </div>
                            );
                        }
                        return null;
                    };

                    return (
                        <div className="p-fluid">


                            {/* Gráfica Histórica */}
                            <div>
                                <h4 style={{ marginBottom: '5px', color: '#374151' }}>Historico semanal</h4>
                                <div style={{ height: '300px', padding: '5px', backgroundColor: 'white', borderRadius: '8px', border: '1px solid #e5e7eb' }}>
                                    {datosHistoricos.length > 0 ? (
                                        <Chart type="line" data={getChartData(datosHistoricos)} options={chartOptions} style={{ height: '100%' }} />
                                    ) : (
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', color: '#6b7280' }}>
                                            No hay datos históricos disponibles
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* DataTable de Bitácoras */}
                            <div>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
                                    <h4 style={{ margin: 0, color: '#374151' }}>Historial de Bitácoras</h4>
                                    <Tag value={`Total: ${bitacoras.length}`} severity="info" style={{ fontSize: '0.875rem' }} />
                                </div>
                                <DataTable
                                    value={bitacoras}
                                    stripedRows
                                    scrollable
                                    scrollHeight="300px"
                                    virtualScrollerOptions={{ itemSize: 46 }}
                                    emptyMessage="No hay bitácoras registradas"
                                    rowClassName={rowClassName}
                                    style={{ fontSize: 'clamp(0.75rem, 2vw, 0.875rem)' }}
                                >
                                    <Column
                                        header="Incidencias"
                                        body={incidenciasTemplate}
                                        style={{ minWidth: '100px', textAlign: 'center' }}
                                    />
                                    <Column
                                        field="ID"
                                        header="ID Bitácora"
                                        style={{ minWidth: '120px' }}
                                    />
                                    <Column
                                        field="FECHA"
                                        header="Fecha"
                                        body={(rowData) => {
                                            ;
                                            return formateoBasico(rowData.FECHA);
                                        }}
                                        style={{ minWidth: '100px' }}
                                    />

                                    <Column
                                        field="% AFORO"
                                        header="Registro de aforo"
                                        body={(rowData) => textTemplateAforos(parseFloat(rowData['% AFORO']))}
                                        style={{ minWidth: '100px', textAlign: 'center' }}
                                    />
                                    <Column
                                        field="% ECO_DRIVE"
                                        header="Eco-Drive > 90%"
                                        body={(rowData) => textTemplateEcodrive(parseFloat(rowData['% ECO_DRIVE'] * 10))}
                                        style={{ minWidth: '100px', textAlign: 'center' }}
                                    />
                                    <Column
                                        field="% EFECTIVIDAD"
                                        header="Apego al trazo"
                                        body={(rowData) => textTemplateEfectividad(rowData['% EFECTIVIDAD'] ? parseFloat(rowData['% EFECTIVIDAD']) : 0)}
                                        style={{ minWidth: '100px', textAlign: 'center' }}
                                    />
                                    <Column
                                        field="% PUNTUALIDAD"
                                        header="Minutos de atraso"
                                        body={(rowData) => textTemplatePuntualidad(rowData['% PUNTUALIDAD'] ? parseFloat(rowData['% PUNTUALIDAD']) : 0)}
                                        style={{ minWidth: '100px', textAlign: 'center' }}
                                    />
                                    <Column
                                        field="% ARRANQUE"
                                        header="Arranque en inicio"
                                        body={(rowData) => textTemplateArranque(rowData['% ARRANQUE'])}
                                        style={{ minWidth: '100px', textAlign: 'center' }}
                                    />
                                    <Column
                                        field="CALIFICACION"
                                        header="Calificación"
                                        body={(rowData) => textTemplate(rowData.CALIFICACION * 10)}
                                        style={{ minWidth: '100px', textAlign: 'center' }}
                                    />

                                </DataTable>
                            </div>
                        </div>
                    );
                })()}
            </Dialog>

            {/* Botón flotante para scroll to top */}
            {showScrollTop && (
                <Button
                    icon="pi pi-arrow-up"
                    onClick={scrollToTop}
                    className="p-button-rounded p-button-primary"
                    style={{
                        position: 'fixed',
                        bottom: '2rem',
                        right: '2rem',
                        width: '3rem',
                        height: '3rem',
                        zIndex: 1000,
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
                    }}
                    aria-label="Ir arriba"
                />
            )}
            <ModalRutasExcluidas isOpen={modalRutasExcluidas} setIsOpen={setModalRutasExcluidas}></ModalRutasExcluidas>
        </div>
    );
}


export default EstadisticaDeOperadores;
